import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { getCoOwnerShares } from 'modules/partners/api/getCoOwnerShares';
import { Share } from 'types';

type UseGetCoOwnerSharesProps = {
  partnerId: string;
  isCoOwner: boolean;
  page?: number;
  items?: number;
  sortBy?: string;
  sortOrder?: string;
};

export const useGetCoOwnerShares = ({
  partnerId,
  isCoOwner,
  page = 1,
  items = 10,
  sortBy,
  sortOrder,
}: UseGetCoOwnerSharesProps) => {
  const [coOwnerShares, setCoOwnerShares] = useState<Share[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchCoOwnerShares = useCallback(async () => {
    if (!partnerId || !isCoOwner) return;
    try {
      setIsLoading(true);
      const coOwnerShares = await store.dispatch(
        getCoOwnerShares({ partnerId, page, items, sortBy, sortOrder })
      );

      setCoOwnerShares(coOwnerShares);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
    }
  }, [partnerId, items, page, sortBy, sortOrder]);

  useEffect(() => {
    fetchCoOwnerShares();
  }, [fetchCoOwnerShares]);

  return {
    data: { coOwnerShares },
    isLoading,
    isError,
    actions: {},
  };
};
